/* # =================================================================
# ハンバーガーを開いた時に使用
# ================================================================= */

export default function hamburgerOpen() {
	const icon = document.getElementById("hamburger-icon");
	const open = document.getElementById("hamburger-menu");
	const display = document.getElementById("hamburger-display");
	const body = document.body;

	// クリックイベントリスナーを追加
	icon.addEventListener("click", function() {
		icon.classList.toggle("js-click-hamburger");
		open.classList.toggle("js-open-hamburger");
		body.classList.toggle("js-fixed");

		if (window.innerWidth >= 1280) {
			display.classList.toggle("js-open-hamburger");

			//リサイズの判定用クラス
			display.classList.toggle("js-flg");
		}
	});

	window.addEventListener("resize", function() {
		if (window.innerWidth >= 1280 && !display.classList.contains("js-flg")) {
			icon.classList.remove("js-click-hamburger");
			open.classList.remove("js-open-hamburger");
			display.classList.remove("js-open-hamburger");
			body.classList.remove("js-fixed");
		}
	});

	document.querySelectorAll('a').forEach((anchor) => {
		anchor.addEventListener('click', function (e) {
			icon.classList.remove("js-click-hamburger");
			open.classList.remove("js-open-hamburger");
			display.classList.remove("js-open-hamburger");
			body.classList.remove("js-fixed");
		});
	});
}